import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	seriesCreated: false,
	seasonCreated: false,
};

const batchContentHandlerSlice = createSlice({
	name: "batchContentHandler",
	initialState,
	reducers: {
		handleSeriesCreated: (state, action) => {
			state.seriesCreated = action.payload;
		},
		handleSeasonCreated: (state, action) => {
			state.seasonCreated = action.payload;
		},
	},
});

export const { handleSeriesCreated, handleSeasonCreated } =
	batchContentHandlerSlice.actions;
export default batchContentHandlerSlice.reducer;
